"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayableArea = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
exports.PlayableArea = (0, react_1.forwardRef)(({ children, style, ...props }, ref) => ((0, jsx_runtime_1.jsx)("div", { ...props, ref: ref, style: {
        flex: "1 1 0",
        minHeight: 0,
        minWidth: 0,
        overflow: "hidden",
        position: "relative",
        ...style,
    }, children: children })));
exports.PlayableArea.displayName = "PlayableArea";
